import { render, staticRenderFns } from "./ShippingSection.vue?vue&type=template&id=4eca08bd&scoped=true"
import script from "./ShippingSection.vue?vue&type=script&lang=js"
export * from "./ShippingSection.vue?vue&type=script&lang=js"
import style0 from "./ShippingSection.vue?vue&type=style&index=0&id=4eca08bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eca08bd",
  null
  
)

export default component.exports